'use es6';

import { insertDateMessagesWithHistoryConfig } from 'conversations-message-history/dates/operators/insertDateMessagesWithHistoryConfig';
import { createSelector } from '@reduxjs/toolkit';
import { MessageHistoryConfig } from '../constants/MessageHistoryConfig';
import { getFilteredMessages } from './getFilteredMessages';
import { getUseSpotlightLauncher } from '../../widget-data/selectors/widgetDataSelectors';
import { getHumanAgentSenderIds } from '../../responders/selectors/getHumanAgentSenderIds';
import { insertResponderJoinedMessages } from '../operators/insertResponderJoinedMessages';
const displayInitialMessageDate = false;
export const getMessagesList = createSelector([getFilteredMessages, getUseSpotlightLauncher, getHumanAgentSenderIds], (filteredMessages, isSpotlight, humanAgentSenderIds) => {
  const messagesWithDates = insertDateMessagesWithHistoryConfig(filteredMessages, MessageHistoryConfig, displayInitialMessageDate);
  if (!isSpotlight) return messagesWithDates;
  return insertResponderJoinedMessages(messagesWithDates, humanAgentSenderIds);
});